import React, { Component } from 'react';
import Tools from '../../tools.js';
import API from '../../api';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Col, Row, Container, Button } from 'react-bootstrap';
import ProjEditForm from './ProjEditForm';
import HashChange from "react-hashchange";

class ProjectsNewApp extends React.Component {
    E_TYPE = {
        ALL: 0,
        SINGLE: 1
    };

    constructor(props) {
        super(props);
        Tools.init();
        API.init(this);

        this.state = {
            formData: {},
            isLoading: false,
            pid: this.props.match.params["id"]
        };

        console.log(this.state);
    }

    render() {
        const { isLoading, formData } = this.state;
        const { onUpdate } = this;

        if (isLoading) {
            return (
                <div className="h1 mx-auto text-center my-5">Loading..</div>
            );
        } else {
            return (
                <ProjEditForm
                    isDisabled={false}
                    title={"新增專案"}
                    formData={formData}
                    onUpdate={onUpdate} />
            );
        }
    }
}

const mapStateToProps = (state) => ({
    id: state.authReducer.id
})

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ProjectsNewApp))